import { TableModel, ITableColumn, AggregrationType, TableRow } from 'app/components/table/table.model';
import { formatNum } from 'app/utils';
import { Table } from 'app/components/table/table';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import React, { useMemo, useEffect, useState } from 'react';
import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { AgtAdzeEmpfehlungVM } from 'app/stores/ui/agt.adzempfehlung.ui.store';
import _ from 'lodash';
import { Icon } from 'app/components/common/Icon';

interface IAdzEmpfehlungListIcon {
	value: number;
	path: string;
}
export const AdzEmpfehlungListIcon = observer((props: IAdzEmpfehlungListIcon) => {
	const { value, path } = props;

	let color: string = 'grey';

	switch (path) {
		case 'googleProfile':
		case 'socialMediaToolbox':
			color = 'green';
			break;
		case 'amisNow':
		case 'serviceToSale':
			color = 'turquoise';
			break;
		case 'akumaPlaner':
		case 'akumaPrime':
			color = 'yellow';
			break;
		case 'meineAllianz':
		case 'kvmSupport':
			color = 'blue';
			break;
		case 'leadNow':
		case 'leadNow':
			color = 'green';
			break;
	}

	return value === 1 ? (
		<span className={`tag is-${color}`}>
			<Icon iconClass={'check'} faModifier="fab" />
		</span>
	) : null;
});

export const AdzEmpfehlungList = observer(() => {
	const { agtAdzEmpfehlungUiStore, anwendungenUiStore, agenturListUiStore, berichteUiiStore, session } = useStore();
	const [loaded, setLoadad] = useState<boolean>(false);

	const year = berichteUiiStore.currentAdzYear;

	const tm = useMemo(() => {
		const tm = new TableModel<AgtAdzeEmpfehlungVM, number>();

		const cols: ITableColumn<AgtAdzeEmpfehlungVM, number>[] = [
			{
				label: 'Agentur',
				path: 'agt.name',
				sortBy: 'agt.name',
				render: AgenturNameCell,
			},
		];
		let aggIf = (val: any) => {
			return val === 1;
		};

		agtAdzEmpfehlungUiStore.schema.forEach((r) => {
			const path = 'item.' + r.path;
			cols.push({
				label: r.label,
				path,
				render: (row: TableRow<AgtAdzeEmpfehlungVM>) => {
					const val = _.get(row.data, path);
					return <AdzEmpfehlungListIcon path={r.path} value={val} />;
				},

				agg: anwendungenUiStore.selectedAgt
					? []
					: [
							{
								path,
								format: formatNum,
								aggType: AggregrationType.count,
								aggIf,
							},
					  ],
			});
		});

		tm.sortBy = 'agt.name';
		tm.setCols(cols);
		tm.idProperty = 'agtId';
		tm.idType = 'number';
		return tm;
	}, [agtAdzEmpfehlungUiStore, berichteUiiStore.currentAdzYear, anwendungenUiStore.selectedAgt]);

	useEffect(() => {
		agtAdzEmpfehlungUiStore.findByYear(year).then((res) => {
			res = agenturListUiStore.applyFilterOnAgt(res) as AgtAdzeEmpfehlungVM[];
			if (anwendungenUiStore.selectedAgt) {
				const agtId = anwendungenUiStore.selectedAgt.agtId;
				res = res.filter((d) => d.agtId === agtId);
			}
			tm.setRowData(res);
			setLoadad(true);
		});
	}, [tm, year, setLoadad, agtAdzEmpfehlungUiStore, anwendungenUiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore]);

	return (
		<>
			{loaded && (
				<>
					<Table stickyFooter={true} tm={tm} />
				</>
			)}
		</>
	);
});
